module.exports = __webpack_public_path__ + "img/side seam.469261c3.png";